import { IntlShape } from 'react-intl'

import { IS_DEV } from '../../config'
import { OrderLine } from '../../services'
import { productPath } from '../../routes/links'

export const getFullOriginLink = (link: string) =>
  !IS_DEV
    ? `${window.location.origin}${link}`
    : `https://marketplace-dev.consultinar.com${link}`

export const getProductFullOriginLink = (
  product: Parameters<typeof productPath>[0]
) => getFullOriginLink(productPath(product))

export const getOrderLinesAutoMessage = (intl: IntlShape, lines: OrderLine[]) =>
  lines.reduce((acc, { product }) => {
    const productNameTitle = intl.formatMessage({
      id: 'chat.order.productName.message',
      defaultMessage: 'Product Name:'
    })

    const fullProductLink = getProductFullOriginLink(product)
    return `${acc}\n ${productNameTitle} ${product.name}\n ${fullProductLink}`
  }, '')
